export default "__VITE_ASSET__1E0T03Vl__"